module.exports = __webpack_public_path__ + "media/lightening-bolt.4b21888a.mp3";